import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router"

import { ForgotPaswordService } from '../../service/forgot-pasword.service';
import { NotificationService } from 'src/app/service/notification.service';
import { customValidation } from 'src/app/manager/customValidators';
import { ResponseHelper } from 'src/app/manager/response.helper';
import { finalize } from 'rxjs/operators';

import * as  moment from 'moment';
import { LoginService } from 'src/app/service/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { HeaderComponent } from 'src/app/common-components/header/header.component';
import { CommonModule } from '@angular/common';

 import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridModule } from 'ag-grid-angular';
import { BASE_AG_GRID_OPTIONS } from 'src/app/service/common-config';
@Component({
  selector: 'app-forgot-password-new',
  templateUrl: './forgot-password-new.component.html',
  styleUrls: ['./forgot-password-new.component.scss'],
  standalone: true,
  imports: [HeaderComponent, FormsModule, CommonModule,AgGridModule, ReactiveFormsModule]
})
export class ForgotPasswordNewComponent implements    OnInit {
gridOptions: GridOptions = {
  pagination: true,
  paginationPageSize: 15,
  rowSelection : 'single',
    suppressColumnVirtualisation: true,
  suppressDragLeaveHidesColumns: true,
...BASE_AG_GRID_OPTIONS,
};


  MyForm: UntypedFormGroup;
  ResetForm: UntypedFormGroup;
  DisplayError: Boolean;
  DisableSubmit: Boolean = false;
  SwitchToReset: Boolean = true;
  ResponseHelper;
  captchaArray = [];
  gradientColor = null;
  captchaData = '';
  timeInterval;
  securityCodeTime;
  CurrentYear;

  showCaptcha: any;
  uniqueKey: any;
  isCaptcha: boolean= false;
  version: string;
  ReleasedVersion: string;
  showCopyright: boolean = false;

  minLength: number;
  maxLength: number;
  constructor(private forgotpasswordservice: ForgotPaswordService, private notificationservice: NotificationService, private router: Router, private route: ActivatedRoute, private notification: NotificationService,
    public loginservice: LoginService,private sanitizer: DomSanitizer) {
      this.version = environment.version;
          this.ReleasedVersion = environment.releasedVersion;
    }


  ngOnInit() {
    this.CurrentYear = (new Date()).getFullYear();
    // this.CreateForm();
    this.CreateResetForm();
    this.route.params.subscribe((params) => {
      console.log('params : ', params);
      if (params && params.securityCode) {
        this.ResetForm.patchValue({ 'Temporary_Password': params.securityCode })
        this.valdateCode(params.securityCode);
      }
    })
    // this.makeid();
    this.ResponseHelper = new ResponseHelper(this.notificationservice);
  }

  valdateCode(code) {
    this.forgotpasswordservice.validateCode(code).subscribe((response: any) => {
      // console.log('response:vinay ', response);
      if (response != null) {
        this.ResetForm.patchValue({ Username: response.Data.Username })
        this.securityCodeTime = moment(response.Data.Mail_Sent_Time).format();
        this.validteTime(response.Data.link_expired);
      }
      else {
        this.redirectToLogin();
      }

    }, (error) => {
      console.log('error: ', error);
      this.ResponseHelper.GetFaliureResponse(error);
      this.redirectToLogin();
      // const response = {
      //   "Message": [
      //     {
      //       "Message": "Employee list.",
      //       "Type": "SUCCESS"
      //     }
      //   ],
      //   "Data": {
      //     "User_Id": 11622,
      //     "Mail_Sent_Time": "2020-09-15T13:04:55.703Z"

      //   }
      // }

    });

  }
  validteTime(link_expired) {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    this.timeInterval = setInterval(() => {
      var ogDate = moment(this.securityCodeTime);
      const diff = moment().diff(ogDate, 'seconds');
      // console.log('diff, this.securityCodeTime, moment().format() : ', diff, this.securityCodeTime, moment().format());

      // vinay commented below three lines
      // if (diff && diff >= 600) {
      //   this.redirectToLogin();
      // }
        if (link_expired == true) {
        this.redirectToLogin();
      }
    }, 1000);
  }
  redirectToLogin() {
    clearInterval(this.timeInterval);
    this.notification.ChangeNotification([{ Message: "Link Expired", Type: "ERROR" }])
    this.router.navigate(['/login'])
  }

  CreateResetForm() {
    this.minLength = environment.passwordMinLength;
    this.maxLength = environment.passwordMaxLength;

    this.ResetForm = new UntypedFormGroup({
      // Username: new FormControl(this.MyForm.controls['username'].value, Validators.required),
      Username: new UntypedFormControl('', Validators.required),
      Temporary_Password: new UntypedFormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)
      ]),
      New_Password: new UntypedFormControl('', [Validators.required
        , Validators.minLength(this.minLength), Validators.maxLength(this.maxLength),
      Validators.pattern(`^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-/(/)/_/+/]).{${this.minLength},}$`)
      ]),
      confirmnewpass: new UntypedFormControl('', [Validators.required,
      ]),
      captchaData: new UntypedFormControl('', [Validators.required]),
      UniqueKey: new UntypedFormControl('', null)
    }, { validators: customValidation.MatchPassword });
    this.callCaptcha();
  }

  ResetPassword() {
    this.DisableSubmit = true;
    console.log('ResetPassword : ', this.ResetForm);
    this.ResetForm.patchValue({ UniqueKey : this.uniqueKey });

    if (this.ResetForm.valid) {
      this.DisplayError = false;
      this.forgotpasswordservice.ResetPassword(this.ResetForm.value).subscribe(
        data => {
          this.ResponseHelper.GetSuccessResponse(data)
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 2000);

        }, err => {
          this.ResponseHelper.GetFaliureResponse(err);
          this.DisableSubmit = false;
          if(err.error != null){
          if(err.error.Data == null && err.error.Message[0].Message != 'Invalid captcha.') {
            this.callCaptcha();
          }
        }
        })
    }
    else {
      this.DisplayError = true;
      this.DisableSubmit = false;
    }
  }

  // Call API for Captcha
  callCaptcha(){
    this.isCaptcha = true;
    this.loginservice.loginCaptcha().subscribe((res:any)=> {
      this.isCaptcha = false;
    // this.ResponseHelper.GetSuccessResponse(res)
    let captcha = res.Data.responseCaptcha;
    this.uniqueKey = res.Data.UniqueKey;
    this.convertToImage(captcha);
    // this.captchaArray.push(this.showCaptcha)
    }, error => {
      this.ResponseHelper.GetFaliureResponse(error)
    })
    this.ResetForm.patchValue({ captchaData: '' })
  }

  convertToImage(captcha) {
    this.showCaptcha = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${captcha}`);
    console.log(this.showCaptcha, 'this.showCaptcha');
  }

  ShowCopyright(){
    this.showCopyright = true;
  }

  closeCopyright(){
    this.showCopyright = false;
  }
}
